// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import {Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router'
import polyfill from 'babel-polyfill';
import 'url-search-params-polyfill';
import store from './store';
import Cookies from 'js-cookie';
import {refresh, getCurrentSchoolTimeBySchoolId, getStudentInfo} from '@/api/login';
import {checkPermission} from '@/utils/utils';

Vue.use(ElementUI);

Vue.config.productionTip = false;

function checkRoutePermission(to, permissionList) {
    let isValidate = true;
    to.matched.some(routeItem => {
        if (routeItem.meta.permissionPath) {
            isValidate = checkPermission(permissionList, routeItem.meta.permissionPath) !== null;
        }
    });
    return isValidate;
}

function resetCookie() {
    sessionStorage.studentId = '';
    sessionStorage.fromExternal = 0;
    sessionStorage.token = '';
    Cookies.set('student-pc-Token', '');
    store.dispatch('SET_USERDETAIL', {
        userDetail: {}
    });
}

router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        resetCookie();
        next();
    } else {
        if (!store.getters.token) {
            if (to.query.token) {
                Cookies.set('student-pc-Token', '');
                var studentId = JSON.parse(to.query.paramJson).studentId;
                sessionStorage.fromExternal = 1;
                sessionStorage.studentId = studentId;
                sessionStorage.token = to.query.token;
            }

            const token = sessionStorage.token || Cookies.get('student-pc-Token');
            const studentId = sessionStorage.studentId;
            const fromExternal = parseInt(sessionStorage.fromExternal) === 1;
            store.dispatch('SET_FROMEXTERNAL', {
                fromExternal
            });
            refresh({
                token
            })
                .then(res => res.data)
                .then(data => {
                    if (data.code === 200) {
                        const loginData = data.data;
                        store.dispatch('SET_TOKEN', {
                            token
                        });
                        store.dispatch('SET_LOGININFO', {
                            userInfo: loginData.userPageModel,
                            schoolInfo: loginData.schoolPageModel,
                            departInfo: loginData.departList[0]
                        });
                        store.dispatch('GetPermission')
                            .then(() => {
                                Promise.all([
                                    getCurrentSchoolTimeBySchoolId()
                                        .then(res => res.data)
                                        .then(data => {
                                            store.dispatch('SET_SCHOOLTIMEID', {
                                                schoolTimeId: data.data.id
                                            })
                                        }),
                                    fromExternal ? getStudentInfo({
                                        idsStr: studentId
                                    })
                                        .then(res => res.data)
                                        .then(data => {
                                            const pageData = data.data;
                                            store.dispatch('SET_USERDETAIL', {
                                                userDetail: pageData && pageData.length !== 0 ? pageData[0] : {}
                                            });
                                        }) : Promise.resolve()
                                ]).then(res => {
                                    if (checkRoutePermission(to, store.getters.permission)) {
                                        next();
                                    } else {
                                        next('/error/502');
                                    }
                                })
                            });

                    } else {
                        Message({
                            message: '登录超时',
                            type: 'error',
                            duration: 3 * 1000
                        });
                        resetCookie();
                        next('/login');
                    }
                })
                .catch(() => {
                    // Message({
                    //     message: '登录超时',
                    //     type: 'error',
                    //     duration: 3 * 1000
                    // });
                    resetCookie();
                    next('/login');
                });
        } else {
            if (checkRoutePermission(to, store.getters.permission)) {
                next();
            } else {
                next('/error/502');
            }
        }
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js